module.exports = __webpack_public_path__ + "static/media/3t.22ac8f04.png";